// tslint:disable:max-line-length

import React from 'react';

export const ActionPrint = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M4,1v4h8V1H4z M2,3v3H0.2C0.1,6,0,6.1,0,6.2v6.5c0,0.1,0.1,0.2,0.2,0.2H3v-3h10v3h2.8c0.1,0,0.2-0.1,0.2-0.2 V6.2C16,6.1,15.9,6,15.8,6H14V3h-1v3H3V3H2z M14.5,7C14.8,7,15,7.2,15,7.5S14.8,8,14.5,8S14,7.8,14,7.5S14.2,7,14.5,7z M4,11v4h8v-4 H4z" />
    </svg>
  );
};
